module.exports = __webpack_public_path__ + "img/p6.0c2e2e79.png";